import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  clearLiffLoginReturnTo,
  getLiffRuntimeState,
  readLiffLoginReturnTo,
  readLiffStateReturnTo,
  rememberLiffLoginReturnTo
} from "./liff";
import { getEnv } from "./env";

function isRestorableLiffReturnPath(value: string): boolean {
  return /^\/t\/[^/]+(?:\/.*)?$/.test(value);
}

function sleep(milliseconds: number): Promise<void> {
  return new Promise((resolve) => {
    window.setTimeout(resolve, milliseconds);
  });
}

export function ReviewDebugLiffReturnHandler() {
  const env = getEnv();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const liffStateReturnTo = readLiffStateReturnTo(location.search);

    if (liffStateReturnTo && isRestorableLiffReturnPath(liffStateReturnTo)) {
      rememberLiffLoginReturnTo(liffStateReturnTo);
    }

    const returnTo = liffStateReturnTo ?? readLiffLoginReturnTo();

    if (!returnTo || !isRestorableLiffReturnPath(returnTo)) {
      return;
    }

    const currentPath = `${location.pathname}${location.search}${location.hash}`;

    if (currentPath === returnTo) {
      return;
    }

    const returnPath = returnTo;
    let cancelled = false;

    async function restoreRoute() {
      if (liffStateReturnTo && env.lineMiniAppLiffId) {
        for (const delayMs of [0, 100, 250, 500, 1000]) {
          if (delayMs > 0) {
            await sleep(delayMs);
          }

          if (cancelled) {
            return;
          }

          const liffState = await getLiffRuntimeState(env.lineMiniAppLiffId);

          if (liffState.isLoggedIn || liffState.hasIdToken) {
            break;
          }
        }
      }

      if (cancelled) {
        return;
      }

      clearLiffLoginReturnTo();
      navigate(returnPath, { replace: true });
    }

    void restoreRoute();

    return () => {
      cancelled = true;
    };
  }, [env.lineMiniAppLiffId, location.hash, location.pathname, location.search, navigate]);

  return null;
}
